<template>
  <div>
    <div class="swiper-container" :style="{height: (data.height ) / 16 + 'rem',marginBottom: (data.marginBottom ) / 16 + 'rem'}">
      <swiper ref="adSwiper" class="swiper" :options="adOption">
        <swiper-slide v-for="(item,index) in data.imgList" :key="index" class="item">
          <img :src="item.url" @click="handleClick(item)">
        </swiper-slide>
      </swiper>
      <div ref="ad-pagination" class="swiper-pagination" />
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';
export default {
  components: { swiper, swiperSlide },
  props: {
    data: {
      type: Object,
      default: () => { return {} }
    }
  },
  data() {
    return {
      adOption: {
        autoplay: {
          deplay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true,
        observer: true,
        observeParents: true,
        pagination: {
          el: '.swiper-pagination',
          bulletClass: 'ad-pagination',
          bulletActiveClass: 'ad-pagination-active',
        },
      },
    }
  },
  methods: {
    handleClick(item) {
      console.log('===', item)
    }
  }
}
</script>

<style lang="less" scoped>
  .swiper-container {
    width: 100%;
    position: relative;

    .swiper {
      width: 100%;
      height: 100%;
      border-radius: 8px;
      overflow: hidden;

      .item {
        width: 100%;
        height: 100%;
        color: #fff;
        border-radius: 8px;

        img {
          width: 100%;
          height: 100%;
          border-radius: 8px;
        }
      }
    }
    .swiper-pagination {
      width: 100%;
      left: 0;
      bottom: 0;
    }
  }
</style>

<style>
  .ad-pagination {
    width: 4px;
    height: 4px;
    border-radius: 2px;
    display: inline-block;
    background-color: #fff;
    margin: 0 5px;
  }

  .ad-pagination-active {
    width: 12px;
    background-color: #fff;
  }
</style>
